import React from "react";
import StdViewResult from "../../components/StudentTabs/StudentViewResult/StdViewResult"

const ViewResult = () => {
  return (
    <div>
      
      <StdViewResult/>
    </div>
  );
};

export default ViewResult;
